import React, { useState, useEffect, useRef } from "react";
import Slider from "react-slick";
import CustomLine from "./CustomLine";
import { getTestimonials } from "../api/api";

const ClientReview = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [testimonials, setTestimonials] = useState([]);
  const sectionRef = useRef(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  useEffect(() => {
    const fetchTestimonials = async () => {
      const data = await getTestimonials();
      if (data.status) {
        setTestimonials(data.data);
      } else {
        console.error("Failed to load testimonials:", data.message);
      }
      setLoading(false);
    };
    fetchTestimonials();
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const ClientBackground = require("../../src/assets/images/clientReviewBg.png");

  return (
    <div
      ref={sectionRef}
      className="custom-padding xl-screen-padding pt-80 pb-80"
      style={{
        backgroundImage: `url(${ClientBackground})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-center mb-8 w-full">
        <div className="text-white text-left md:text-left">
          <div className="flex items-center mb-2">
            <CustomLine color="#FFFFFF" />
            <h3 className="text-p1 font-semibold font-lato ml-2">Reviews</h3>
          </div>
          <h2 className="text-h2 font-semibold font-merriweather">
            Experience with Nutrillion
          </h2>
        </div>
        <div className="text-white md:text-right font-libre">
          <p className="text-left sm:text-end testimonial-size">
            The genuine experiences and heartfelt feedback that highlights the
            trust we've built through our commitment to excellence, quality, and
            customer satisfaction.
          </p>
        </div>
      </div>

      {loading ? (
        <p className="text-center text-lg text-white">Loading testimonials...</p>
      ) : testimonials.length > 0 ? (
        <Slider {...settings}>
          {testimonials.map((testimonial, index) => (
            <div className="p-2" key={testimonial.id}>
              <div
                className={`bg-[rgba(55,45,23,0.5)] text-white p-6 rounded-lg shadow-lg ${isVisible
                    ? index % 2 === 0
                      ? "slide-left"
                      : "slide-right"
                    : "opacity-0"
                  } h-full`}
                style={{ minHeight: "260px" }}
              >
                <div className="flex items-center mb-4">
                  <div>
                    <img
                      src={testimonial.imageUrl}
                      alt={testimonial.name}
                      className="w-12 h-12 rounded-full mr-4 object-cover"
                    />
                  </div>
                  <div>
                    <h4 className="font-semibold text-h2 font-libre">
                      {testimonial.name}
                    </h4>
                    <p className="text-p font-lato">{testimonial.designation}</p>
                  </div>
                </div>

                <p
                  className="text-p md:text-base font-lato italic"
                  dangerouslySetInnerHTML={{ __html: testimonial.description }}
                ></p>

                <div className="mt-2 text-yellow-400 border-none p-0 m-0">
                  ★★★★★
                </div>
              </div>
            </div>
          ))}
        </Slider>
      ) : (
        <p className="text-center text-lg text-white">No testimonials available.</p>
      )}
    </div>
  );
};

export default ClientReview;
